import Constants from 'common/constants'

import {REDUX_SAVE_LOGIN_INFO} from '../SignIn/ActionTypes/ReduxActionTypes'
import {
  ACTIVATE_USERS,
  ADD_DEVICE_TOKEN,
  CONFIRM_PROFILE_PICTURE_UPLOAD,
  CONFIRM_PROFILE_PICTURE_UPLOAD_ANY_USER,
  GET_ACTIVE_STAFF,
  GET_ALL_ACTIVE_EMPLOYEE_ATTENDANCE,
  GET_ALL_ACTIVE_STUDENTS_ATTENDANCE,
  GET_ALL_USERS,
  GET_CHILD_PROFILE,
  GET_PROFILE_PICTURE_UPLOAD_URL,
  GET_PROFILE_PICTURE_UPLOAD_URL_ANY_USER,
  GET_SMS_SERVICES,
  GET_STUDENTS_ATTENDANCE_BY_GRADES,
  GET_STUDENTS_SUBJECT_ATTENDANCE,
  GET_STUDENT_HOUSE_LABEL,
  GET_TEACHERS_SUBJECT_ATTENDANCE,
  GET_USER_MESSAGES,
  GET_USER_PROFILE,
  GET_USER_SETTINGS,
  INACTIVATE_USERS,
  LOGOUT_USERS,
  MOVE_USERS_TO_JUNK,
  REGENERATE_USER_PASSWORDS,
  SEND_FEEDBACK,
  SET_USER_SETTINGS,
  UPDATE_PASSWORD,
  USER_IMPERSONATE,
  VERIFY_PASSWORD,
} from './ActionTypes/ApiActionTypes'
import {REDUX_SAVE_USER_SETTINGS} from './ActionTypes/ReduxActionTypes'

export const getAllUsers = (params, onSuccess, onFailure) => {
  return {
    type: GET_ALL_USERS,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_get_all_users,
      getString: '',
      body: params,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

export const checkLoginStatus = (result) => {
  return {
    type: REDUX_SAVE_LOGIN_INFO,
    payload: {
      result,
    },
  }
}

//deviceType determined from headers, new backend would use the new firebase project
export const addDeviceToken = (token) => {
  return {
    type: ADD_DEVICE_TOKEN,
    payload: {
      apiUrl: Constants.api_device_token,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {
        deviceToken: token,
      },
      reduxActionType: '',
    },
  }
}

export const sendFeedback = (body, onSuccess) => {
  return {
    type: SEND_FEEDBACK,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_feedback,
      noAccessToken: true,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
    },
  }
}

export const setSettings = (body, onSuccess) => {
  return {
    type: SET_USER_SETTINGS,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_setting,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      response: {result: body},
      reduxActionType: REDUX_SAVE_USER_SETTINGS,
    },
  }
}

export const getSettings = () => {
  return {
    type: GET_USER_SETTINGS,
    payload: {
      apiUrl: Constants.api_setting,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: REDUX_SAVE_USER_SETTINGS,
    },
  }
}

export const getProfile = (onSuccess) => {
  return {
    type: GET_USER_PROFILE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_profile,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

/**
 * The signed-in student's house badge for the header. The API answers
 * `{house: null}` unless the school's General Settings switch is on and the
 * student is in a house.
 * @param {(response: any) => void} onSuccess
 * @param {(error: any) => void} onFailure
 */
export const getStudentHouseLabel = (onSuccess, onFailure) => {
  return {
    type: GET_STUDENT_HOUSE_LABEL,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_get_student_house_label,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

export const getChildProfile = (body, onSuccess) => {
  return {
    type: GET_CHILD_PROFILE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_child_profile,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
    },
  }
}

export const getUserMessages = (onSuccess, onFailure) => {
  return {
    type: GET_USER_MESSAGES,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_get_user_messages,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

export const getProfilePictureSignedUrl = (body, onSuccess, onFailure) => {
  return {
    type: GET_PROFILE_PICTURE_UPLOAD_URL,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_get_profile_picture_upload_url,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
    },
  }
}
export const getProfilePictureSignedUrlAnyUser = (id, body, onSuccess, onFailure) => {
  return {
    type: GET_PROFILE_PICTURE_UPLOAD_URL_ANY_USER,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_get_user_profile_picture_upload_url(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
    },
  }
}

export const confirmProfilePictureUpload = (body, onSuccess, onFailure) => {
  return {
    type: CONFIRM_PROFILE_PICTURE_UPLOAD,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_confirm_profile_picture_upload,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
    },
  }
}
export const confirmProfilePictureUploadAnyUser = (id, body, onSuccess, onFailure) => {
  return {
    type: CONFIRM_PROFILE_PICTURE_UPLOAD_ANY_USER,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_confirm_profile_picture_upload_any_user(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
    },
  }
}

export const getActiveStaff = (data, onSuccess, onFailure) => {
  return {
    type: GET_ACTIVE_STAFF,
    payload: {
      apiUrl: Constants.api_user_active_staff,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSmsServices = (data, onSuccess, onFailure) => {
  return {
    type: GET_SMS_SERVICES,
    payload: {
      apiUrl: Constants.api_sms_services,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTeacherStaffAttendance = (data, onSuccess, onFailure) => {
  return {
    type: GET_ALL_ACTIVE_EMPLOYEE_ATTENDANCE,
    payload: {
      apiUrl: Constants.api_user_all_active_users_attendance,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getStudentsAttendance = (data, onSuccess, onFailure) => {
  return {
    type: GET_ALL_ACTIVE_STUDENTS_ATTENDANCE,
    payload: {
      apiUrl: Constants.api_user_all_active_students_attendance,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getStudentsAttendanceByGrades = (data, onSuccess, onFailure) => {
  return {
    type: GET_STUDENTS_ATTENDANCE_BY_GRADES,
    payload: {
      apiUrl: Constants.api_user_all_active_students_attendance_by_grades,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTeacherSubjectAttendance = (data, onSuccess, onFailure) => {
  return {
    type: GET_TEACHERS_SUBJECT_ATTENDANCE,
    payload: {
      apiUrl: Constants.api_user_teachers_subject_attendance,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getStudentsSubjectAttendance = (data, onSuccess, onFailure) => {
  return {
    type: GET_STUDENTS_SUBJECT_ATTENDANCE,
    payload: {
      apiUrl: Constants.api_user_students_subject_attendance,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const inActivateUsers = (body, onSuccess, onFailure) => {
  return {
    type: ACTIVATE_USERS,
    payload: {
      apiUrl: Constants.api_inactive_users,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const activateUsers = (userIds, onSuccess, onFailure) => {
  return {
    type: INACTIVATE_USERS,
    payload: {
      apiUrl: Constants.api_activate_users,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: {
        ids: userIds,
      },
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const moveUsersToJunk = (userIds, onSuccess, onFailure) => {
  return {
    type: MOVE_USERS_TO_JUNK,
    payload: {
      apiUrl: Constants.api_move_users_to_junk,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: {
        ids: userIds,
      },
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const impersonateUser = (userId, onSuccess, onFailure, additionalParams) => {
  const isAdmissionUser = additionalParams?.isAdmissionUser || false
  return {
    type: USER_IMPERSONATE,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_user_impersonate,
      getString: '',
      body: {userId, isAdmissionUser},
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

export const verifyPassword = (params, onSuccess, onFailure) => {
  return {
    type: VERIFY_PASSWORD,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_verify_password,
      getString: '',
      body: params,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

export const updatePassword = (params, onSuccess, onFailure) => {
  return {
    type: UPDATE_PASSWORD,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_update_password,
      getString: '',
      body: params,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

/**
 * Regenerate + email system-generated passwords (random password provisioning).
 * @param {{selected_ids?: number[], user_type?: 'student'|'parent'|'teacher'|'staff', user_ids?: number[], send_email?: 0|1}} body
 */
export const regenerateUserPasswords = (body, onSuccess, onFailure) => {
  return {
    type: REGENERATE_USER_PASSWORDS,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_regenerate_user_passwords,
      getString: '',
      body,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

export const logoutUsers = (body, onSuccess, onFailure) => {
  return {
    type: LOGOUT_USERS,
    payload: {
      apiUrl: 'user/logout-all',
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
